import {
  SIGN_OUT,
  GET_EVOM_ACCOUNT_WALLETS,
  GET_EVOM_ACCOUNT_SELECTION,
  CLEAR_EVOM_ACCOUNT_SELECTION,
} from 'constants/ActionTypes';

const INIT_STATE = {
  evomAccountWallets: {
    data: [],
    count: 0
  },
  evomAccountSelection: {
    data: [],
    count: 0
  },
};

export default (state = INIT_STATE, action) => {
  switch (action.type) {
    case SIGN_OUT: {
      return INIT_STATE;
    }

    case GET_EVOM_ACCOUNT_WALLETS: {
      return {
        ...state,
        evomAccountWallets: action.payload,
      };
    }

    case GET_EVOM_ACCOUNT_SELECTION: {
      return {
        ...state,
        evomAccountSelection: action.payload,
      };
    }

    case CLEAR_EVOM_ACCOUNT_SELECTION: {
      return {
        ...state,
        evomAccountSelection: {
          data: [],
          count: 0
        }
      };
    }

    default: {
      return state;
    }
  }
}
